export default "__VITE_PUBLIC_ASSET__65186890__"